import React, { useEffect, useRef } from "react";


export const Services = (props) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;

    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add("is-visible");
          observer.unobserve(section); // animação só uma vez
        }
      },
      { threshold: 0.2 } // quando 20% da seção estiver visível
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return (
    <div id="serv" ref={sectionRef}>
      <div className="container">
        <div className="row d-flex">
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Aproveite os benefícios que você mais espera e precisa!</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>               
              {/* <div className="btn btn-custom btn-lg page-scroll">
                <a className="text-white" href="/garantias">Garantias</a>
              </div> */}
            </div>
          </div>
          <div className="col-xs-12 col-md-6 d-flex">
            <img src="img/team.png" className="img-responsive scale-x" alt="" style={{ position: "relative", top: "10px" }}/>
          </div>
        </div>
      </div>
    </div>
  );
};
